var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./CampaignList.js"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-55b3eefc!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CampaignList.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Campaign/CampaignList.vue
// module id = 568
// module chunks = 0